<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="preferencias.Titulo"
                  label="Título"
                  prepend-icon="description"
                  id="preferencias-add-item"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete 
                  v-model="preferencias.ModeloAtividade"
                  :items="modelosAtividadeAtivo"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Modelo Atividade"
                  no-data-text="Registro não encontrado."
                  prepend-icon="label_important"
                  auto-select-first
                  clearable
                  @change="changeModeloAtividade"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete 
                  v-model="preferencias.Cliente"
                  :items="clientesAtivo"
                  item-text="Fantasia"
                  return-object
                  menu-props="auto"
                  label="Cliente"
                  no-data-text="Registro não encontrado."
                  prepend-icon="person"
                  auto-select-first
                  clearable
                  @change="changeCliente"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete 
                  v-model="tag.Descricao"
                  :items="tagsAtivo"
                  item-text="Descricao"
                  return-object
                  id="tag-add-item"
                  menu-props="auto"
                  label="Adicionar Tag"
                  no-data-text="Registro não encontrado."
                  prepend-icon="label"
                  auto-select-first
                  @change="changeTag"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-card>
                  <v-toolbar dense dark color="primary">
                    <v-toolbar-title>Tags</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="pa-0">
                    <!-- Lista Tags -->
                    <v-flex xs12>
                      <v-list v-if="preferencias.Tags.length">
                        <template v-for="(tag, index) in preferencias.Tags">
                          <v-list-tile :key="tag.IdTag">
                            <v-list-tile-content>
                              <v-list-tile-title>{{ tag.Descricao }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                              <div class="d-flex justify-end">
                                <v-tooltip bottom>
                                  <v-btn
                                    icon
                                    flat
                                    small
                                    class="mx-0"
                                    slot="activator"
                                    @click="excluiTag(tag)"
                                  >
                                    <v-icon small>delete</v-icon>
                                  </v-btn>
                                  <span>Excluir</span>
                                </v-tooltip>
                              </div>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider
                            v-if="index !== preferencias.Tags.length - 1"
                            :key="index + tag.Descricao"
                            class="mx-2"
                          ></v-divider>
                        </template>
                      </v-list>
                      <div v-else class="d-flex my-3">
                        <span class="text-xs-center font-weight-bold">Nenhuma tag adicionada à esse item projeto.</span>
                      </div>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ItemProjetoPreferencias from '@/domain/projeto/ItemProjetoPreferencias';

export default {
  name: 'ModalPreferenciasItemProjeto',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    itemProjeto: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      preferencias: new ItemProjetoPreferencias(),
      tag: {
        IdTag: null,
        Descricao: ''
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.inicializaBuscas();
        this.inicializaJsonPreferencias();
      } 
      this.$nextTick(() => document.getElementById('preferencias-add-item').focus());
    }
  },
  computed: {
    ...mapGetters(['modelosAtividadeAtivo', 'clientesAtivo', 'tagsAtivo']),
    computedTitle() {
      return this.itemProjeto ? `Preferências: ${this.itemProjeto.Item}` : 'Preferências Item Projeto';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : '60%';
    },
  },
  methods: {
    ...mapActions([
      'fetchTags',
      'fetchModelosAtividade',
      'fetchClientes',
      'updateItemProjeto'
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    inicializaJsonPreferencias() {
      if (this.itemProjeto.Preferencias) {
        const {
          Titulo,
          IdModeloAtividade,
          ModeloAtividade,
          IdCliente,
          Cliente,
          Tags
        } = JSON.parse(this.itemProjeto.Preferencias);
        
        this.preferencias.Titulo = Titulo || '';
        this.preferencias.IdModeloAtividade = IdModeloAtividade || null;
        this.preferencias.ModeloAtividade = ModeloAtividade || '';
        this.preferencias.IdCliente = IdCliente || null;
        this.preferencias.Cliente = Cliente || '';
        this.preferencias.Tags = Tags || [];
      } else {
        this.preferencias = new ItemProjetoPreferencias();
      }
    },
    async inicializaBuscas() {
      if (!this.modelosAtividadeAtivo.length) this.fetchModelosAtividade();
      if (!this.clientesAtivo.length) this.fetchClientes();
      if (!this.tagsAtivo.length) this.fetchTags();
    },
    async changeTag(obj) {
      const tagExiste = this.preferencias.Tags.find(t => t.IdTag === obj.IdTag);
      if (tagExiste) return;
      
      const newTag = {
        IdTag: obj.IdTag,
        Descricao: obj.Descricao
      }
      this.preferencias.Tags.push(newTag);
    },
    async changeModeloAtividade(obj) {
      if (obj && typeof obj === 'object') {
        this.preferencias.IdModeloAtividade = obj.IdModeloAtividade;
        this.preferencias.ModeloAtividade = obj.Descricao;
      } else {
        this.preferencias.IdModeloAtividade = null;
        this.preferencias.ModeloAtividade = '';
      }
    },
    async changeCliente(obj) {
      if (obj && typeof obj === 'object') {
        this.preferencias.IdCliente = obj.IdCliente;
        this.preferencias.Cliente = obj.Fantasia;
      } else {
        this.preferencias.IdCliente = null;
        this.preferencias.Cliente = '';
      }
    },
    async excluiTag(tag) {
      this.preferencias.Tags = this.preferencias.Tags.filter(t => t.IdTag !== tag.IdTag);
    },
    async adiciona() {
      this.loading = true;
      this.itemProjeto.Preferencias = JSON.stringify(this.preferencias);
      try {
        await this.updateItemProjeto(this.itemProjeto);
        this.loading = false;
        this.showNotification({ text: `Preferências do Item: ${this.itemProjeto.Item} atualizadas com sucesso.`, status: 'success' });
        this.$emit('itemProjetoPreferenciasAtualizado');
      } catch (error) {
        this.loading = false;
        this.showNotification({ text: `Ocorreu um erro ao atualizar as preferências do Item: ${this.itemProjeto.Item}. ${error}`, status: 'error' });
      }
    }
  },
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
